// Mirrors owedAmount in vlg-api services/payments/payments.js — a partially collected payment is
// drafted for the remainder only, so anything stating a figure to an operator must subtract.
export const computeOwed = (payment) =>
  Math.round((((payment?.amount) || 0) - ((payment?.amountPaid) || 0)) * 100) / 100

// `processing` means the worker already picked the residual up for this run, so it is no longer
// outstanding — showing it would send operators chasing money that is on its way.
const COLLECTED_OR_IN_FLIGHT = ['processing', 'cleared']

export const isPartiallyCollected = (payment) => {
  const paid = payment?.amountPaid || 0
  const amount = payment?.amount || 0

  if (paid <= 0 || paid >= amount) return false
  if (payment?.settledByPayment) return false

  return !COLLECTED_OR_IN_FLIGHT.includes(payment?.status)
}
